// HotX CDN BSC 充值 Console API，更新时间：2026-09-03 CST。地址仅随有效 BSC 订单返回。
import { ControlPlaneApiError } from '@hotx-cdn/shared';
import { httpClient } from './client';

export type BscAssetCode = 'USDT_BEP20' | 'BNB';

export interface BscRechargeConfig {
  network: 'BSC_MAINNET';
  rechargeEnabled: boolean;
  providerConfigured: boolean;
  orderTtlMinutes: number;
  maxActiveOrders: number;
  maxDailyEmptyOrders: number;
  addressVisibleOnlyWithActiveOrder: boolean;
  assets: Array<{ assetCode: BscAssetCode; displayName: string; enabled: boolean; network: string }>;
}

export interface BscRechargeOrder {
  id: number;
  orderId: string;
  selectedAsset: BscAssetCode;
  network: 'BSC_MAINNET';
  status: string;
  expiresAt: string;
  createdAt: string;
  detectedCount: number;
  creditedCount: number;
  addressVisible: boolean;
  depositAddress?: string | null;
  paymentQrContent?: string | null;
  scanMode: 'ORDER_ACTIVE' | 'CLOSED';
}

export interface BscDeposit {
  depositUid: string;
  orderId?: string;
  txHash: string;
  assetCode: BscAssetCode | 'UNKNOWN_TOKEN';
  tokenContract?: string;
  decimalAmount: string;
  usdValue?: string;
  creditedPoints?: string;
  confirmations: number;
  requiredConfirmations: number;
  state: string;
  detectedAt: string;
  creditedAt?: string;
}

const messages: Record<string, string> = {
  BSC_RECHARGE_DISABLED: 'BSC 充值通道正在配置中，请稍后再试。',
  BSC_PROVIDER_NOT_CONFIGURED: 'BSC 充值通道正在配置中，请稍后再试。',
  BSC_PROVIDER_UNAVAILABLE: 'BSC 链上服务暂时繁忙，请稍后再试。',
  BSC_DAILY_EMPTY_ORDER_LIMIT: '今日未到账订单已达到 10 笔，请明日再试或联系我们。',
  BSC_ORDER_NOT_FOUND: '订单不存在或已关闭。',
  BSC_TX_HASH_INVALID: '请输入有效的 BSC 交易哈希。',
  BSC_DEPOSIT_NOT_FOUND: '暂未找到该交易，请稍后再试。',
  BSC_DEPOSIT_NOT_OWNED: '该交易未转入您的 BSC 专属地址。'
};

export function bscErrorMessage(error: unknown, fallback: string) {
  return error instanceof ControlPlaneApiError ? messages[error.code] || fallback : fallback;
}

const base = '/api/v1/bsc-recharge';
export const bscRechargeApi = {
  config: () => httpClient.get<BscRechargeConfig>(base + '/config'),
  activeOrder: () => httpClient.get<BscRechargeOrder | null>(base + '/orders/active'),
  createOrder: (assetCode: BscAssetCode, clientRequestId: string) =>
    httpClient.post<BscRechargeOrder>(base + '/orders', { assetCode, clientRequestId }),
  order: (orderId: string) => httpClient.get<BscRechargeOrder>(base + '/orders/' + encodeURIComponent(orderId)),
  cancel: (orderId: string) => httpClient.post<BscRechargeOrder>(base + '/orders/' + encodeURIComponent(orderId) + '/cancel'),
  orders: (page = 1, size = 20) => httpClient.get<{ items: BscRechargeOrder[]; total: number }>(base + '/orders', { params: { page, size } }),
  deposits: (page = 1, size = 20) => httpClient.get<{ items: BscDeposit[]; total: number }>(base + '/deposits', { params: { page, size } }),
  selfQuery: (txHash: string) => httpClient.post<{ matched: boolean; txHash: string }>(base + '/self-query', { txHash })
};
